import ManCrossHeatmapPage from './ManCrossHeatmapPage';

// ── Mapeo de dimensión → perfil de riesgo conductual ─────────────────────────
// Alineado con SELFCARE_DIMENSION_DEFS del informe individual IASH.
const PROFILE_BY_DIM = {
    D1: 'Fatigado',
    D2: 'Impulsivo',
    D3: 'Distraído',
    D4: 'Silencioso',
    D5: 'Indisciplinado',
    D6: 'Aislado',
    D7: 'Desconectado',
};

// ── Estilos de celda IASH (semáforo: 50 / 65 / 80) ───────────────────────────

const getCellStyle = (score) => {
    if (score == null || !Number.isFinite(score)) return { bg: '#F4F8FE', text: '#617993' };
    if (score < 50) return { bg: '#FFE5E5', text: '#F3202A' };
    if (score < 65) return { bg: '#FFF0D6', text: '#F48732' };
    if (score < 80) return { bg: '#FFFBE6', text: '#856404' };
    return              { bg: '#E8F8F0', text: '#62C190' };
};

const getBadgeStyle = (score) => {
    if (score == null || !Number.isFinite(score)) return { bg: '#617993', text: '#fff' };
    if (score < 50) return { bg: '#F3202A', text: '#fff' };
    if (score < 65) return { bg: '#F48732', text: '#fff' };
    if (score < 80) return { bg: '#D4AC0D', text: '#574400' };
    return              { bg: '#62C190',  text: '#fff' };
};

/**
 * Footer IASH: menciona las 2 dimensiones con mayor déficit del área más crítica.
 * Umbral de "falla": score < 65 (RIESGO MODERADO o superior).
 */
const buildFooter = (areaRows, topDims) => {
    if (!areaRows.length) return '';
    const worst = areaRows[0];
    if (!worst.name) return '';

    const failingDims = topDims
        .filter(d => worst.dimScores[d.key] != null && worst.dimScores[d.key] < 65)
        .sort((a, b) => (worst.dimScores[a.key] ?? 999) - (worst.dimScores[b.key] ?? 999))
        .slice(0, 2);

    if (failingDims.length >= 2) {
        const d1 = failingDims[0];
        const d2 = failingDims[1];
        const s1 = Math.round(worst.dimScores[d1.key]);
        const s2 = Math.round(worst.dimScores[d2.key]);
        const p1 = PROFILE_BY_DIM[d1.displayCode] || d1.firstWord;
        const p2 = PROFILE_BY_DIM[d2.displayCode] || d2.firstWord;
        return `${worst.name} tiene déficit crítico simultáneo en ${p1} (${s1}) y ${p2} (${s2}) — co-falla conductual activa.`;
    }
    if (failingDims.length === 1) {
        const d1 = failingDims[0];
        const s1 = Math.round(worst.dimScores[d1.key]);
        const p1 = PROFILE_BY_DIM[d1.displayCode] || d1.firstWord;
        return `${worst.name} presenta déficit en ${p1} (${s1}) — intervención prioritaria requerida.`;
    }
    return `${worst.name} y sus dimensiones están sobre el umbral de autocuidado — reforzar lo logrado.`;
};

// ── Config IASH (objeto estable fuera del componente) ─────────────────────────

/** Etiqueta de columna: muestra el nombre del perfil en lugar del código de dimensión */
const getDimHeader = (dim) => ({
    primary:   PROFILE_BY_DIM[dim.displayCode] || dim.displayCode,
    secondary: '',
});

const IASH_HEATMAP_CONFIG = {
    title:            'Riesgo por Área',
    subtitle:         'Mapa de IASH',
    promLabel:        'IASH PROM.',
    scoreLabel:       'IASH',
    calloutThreshold: 65,
    deficitLabel:     'autocuidado',
    noteSuffix:       'del IASH total',
    getCellStyle,
    getBadgeStyle,
    buildFooter,
    getDimHeader,
};

// ── Componente ────────────────────────────────────────────────────────────────

const ManCrossPageHeatmapIASH = ({ reportData, headerText, pageNumber }) => (
    <ManCrossHeatmapPage
        headerText={headerText}
        pageNumber={pageNumber}
        totals={reportData?.payload?.totals?.iash || {}}
        byAreaAndDim={reportData?.payload?.iash_by_area_and_dimension || {}}
        config={IASH_HEATMAP_CONFIG}
    />
);

export default ManCrossPageHeatmapIASH;
